<template>
    <MainPage @clickBack="gotoMain()">
        <template v-slot:header>
            <div class="header-title">
                {{ lbl.contactUS.title }}
            </div>
        </template>
        <div class="content-contact-us">
            <div class="address-title">
                <img src="@/assets/icon/contact/ic-address-contact-dark.svg" alt="">
                <span class="address-title-text">{{ lbl.contactUS.address }}</span>
            </div>
            <div class="address-content">
                <div class="address-content-title">Buzzebees Co.,Ltd. (Head Quarter)</div>
                <div class="address-content-description">100/81-84 and 100/86-87 Vongvanij Complex B Building, FL. 25, 26 Rama IX Road, Huai Kwang Huai Kwang, Bangkok 10310</div>
            </div>
            <div class="other-contact">
                <div class="other-contact-email">
                    <img src="@/assets/icon/contact/ic-mail-contact-dark.svg" alt="">
                    <span class="email-title">{{ lbl.contactUS.email }}</span>
                    <div class="email-text">support@buzzebees.com</div>
                </div>
                <div class="other-contact-phone">
                    <img src="@/assets/icon/contact/ic-phone-contact-dark.svg" alt="">
                    <span class="phone-title">{{ lbl.contactUS.mobile_number }}</span>
                    <div class="phone-text"><a href="tel:027603988">02-645-1212</a></div>
                </div>
            </div>
            <div class="contact-detail">
                <div>{{ lbl.contactUS.contact_detail }}</div>
            </div>
        </div>
        <div class="map-container">
            <div class="map map-area" id="map"></div>
            <div class="location-detail" @click="clickGoogleMaps()">
                <div class="map-content">
                    <div class="map-shadow"></div>
                    <div class="map-content-title">
                        <img src="../../../assets/icon/map-bzbs-logo.png" alt="">
                    </div>
                    <div class="divider"></div>
                    <div class="map-content-detail">
                        <div class="map-header">Buzzebees Co.,Ltd. (Head Quarter)</div>
                        <div class="map-detail">100/81-84 and 100/86-87 Vongvanij Complex B Building, FL. 25, 26
                            Rama IX Road, Huai Kwang Huai Kwang, Bangkok 10310
                        </div>
                    </div>
                </div>
                <!-- <div class="position-arrow">
                    <div class="arrow"></div>
                </div> -->
            </div>
        </div>


    </MainPage>
</template>

<script>
import MainPage from '@/components/Layout/Page/MainPage.vue';
//lib
import { Loader } from '@googlemaps/js-api-loader'
// serve
import MapApi from '../service/MapApi'
// helper
import ConfigManager from '@/config/ConfigManager'

import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    name: "ContactUs",
    mixins: [LocaleMixin],
    components: {
        MainPage
    },
    data: function () {
        return {
            map: null,
            googleMaps: null,
            geocoder: null,
            currentLat: 0,
            currentLng: 0,
            markerPin: null,
        };
    },
    created: async function () {
        await this.getCurrentLocation();
        await this.initialMaps();
    },
    methods: {
        gotoMain: function() {
            this.$router.back()
        },
        getCurrentLocation: function () {
            return new Promise((resolve) => {
                MapApi.getCurrentLocation().then((location) => {
                    console.log(location);
                    // this.currentLat = location.lat;
                    // this.currentLng = location.lng;

                    //Buzzebees location 13.7550382,100.5726832
                    this.currentLat = 13.7550382;
                    this.currentLng = 100.5726832;
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    console.log(location);
                    //Buzzebees location 13.7550382,100.5726832
                    this.currentLat = 13.7550382;
                    this.currentLng = 100.5726832;
                    resolve();
                });
            });
        },
        initialMaps: function () {
            return new Promise((resolve) => {
                var key = ConfigManager.getGoogleMapKey();
                const loader = new Loader({
                    apiKey: key,
                    version: "weekly",
                    libraries: ["places"]
                });
                loader.load().then((google) => {
                    this.geocoder = new google.maps.Geocoder();
                    this.map = new google.maps.Map(document.getElementById("map"), {
                        center: {
                            lat: this.currentLat + 0.005,
                            lng: this.currentLng,
                        },
                        zoom: 15,
                        mapTypeId: "roadmap",
                        disableDefaultUI: true,
                        fullscreenControl: false,
                        clickableIcons: false,
                        clickableLabels: false,
                        zoomControl: true,
                        draggable: false
                    });
                    // alert("load Success");
                    // this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions);
                    this.googleMaps = google;
                    this.map.addListener("click", (event) => {
                        this.clickGoogleMaps(event);
                    });
                    // this.getCurrentLocation();
                    // this.initAutocomplete();
                    // if (!notPinCurrent) {
                    //     this.pinCurrent(this.currentLat, this.currentLng)
                    // }
                    this.setMarker(this.currentLat, this.currentLng);
                    // this.getGeoLocation(this.currentLat, this.currentLng);
                    resolve(true);
                })
                    .catch(e => {
                    console.log(e);
                    // do something
                });
            });
        },
        setMarker: function (lat, lng) {
            let position = {
                lat: lat,
                lng: lng,
            };
            this.markerPin = new this.googleMaps.maps.Marker({
                map: this.map,
                position: position,
            });
        },
        clickGoogleMaps: function () {
            window.open("https://g.page/BuzzeBees?share", "_blank")
        },
    },

}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "../style/ContactUs.scss";

    .map-container {
        background-color: #fff;
        padding: 25px 48px 30px;
        // margin-bottom: 30px;
        border-radius: 0px 0px 5px 5px;
        position: relative;
        height: 355px;
    }
    .map-area {
        height: 100%;
        border-radius: 10px;
        position: relative;
    }
    .location-detail {
        cursor: pointer;
        position: absolute;
        top: 51%;
        left: 50%;
        transform: translate(-50%, -60%);
        width: 100%;
        max-width: 364px;
        @include max-mobile {
            top: 25%;
            padding: 25px;
        }
        // @include min-height-desktop-hd {
        //     top: 28%;
        //     left: 50%;
        // }
        // @include min-height-desktop-hdp {
        //     top: 28%;
        //     left: 50%;
        // }
        // @include min-height-desktop-fhd {
        //     top: 28%;
        //     left: 50%;
        // }
        .map-content {
            background-image: url("../../../assets/icon/map-geo-background.png");
            // background-color: #fff;
            background-repeat: no-repeat;
            border-radius: 8px;
            background-size: 100% 100%;

            .map-shadow {
                z-index: -1;
                position: absolute;
                height: 95%;
                width: 100%;
                border-radius: 10px;
                box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.16);
            }

            .map-content-title {
                // background: $main-orange-color;
                padding: 10px 16px 0px 16px;
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
                @include max-mobile {
                    padding: 14px 20px 0px 20px;
                }
            }

            .divider {
                width: 100%;
                background:#cdcdcd;
                height: 1px;
            }

            .map-content-detail {
                font-size: 16px;
                color: $a-black-333333;
                padding: 8px 15px 15px 15px;
                @include max-mobile {
                    padding: 18px 24px 32px 24px;
                }
                .map-header {
                    font-family: 'PRT-Medium';
                }
            }

            // .position-arrow{
            //     display: flex;
            //     justify-content: center;
            //     .arrow {
            //         width: 0;
            //         height: 0;
            //         border-left: 10px solid transparent;
            //         border-right: 10px solid transparent;

            //         border-top: 10px solid #f00;
            //     }
            // }
        }
    }
</style>
